<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-listar #ctrl URL="articulos-sucursal" titulo="Artículos / Catalogo"></app-listar>

<!-- Menu principal  menutitulo="titulo del modulo en el que estamos con el nombre como se encuentra en enviroment" menuactual="nombre del hub donde estamos como se especifico en el routing"-->
<app-sistema-menu menutitulo="Catalogo" menuactual="catalogo"></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda menutitulo="titulo del modulo enviroment" -->
        <app-sistema-menu-aside menuactual="Catalogo"></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- Opciones y busqueda -->
            <section class="hero" [ngClass]=" {'is-dark': ctrl.busquedaActivada, 'is-primary': !ctrl.busquedaActivada } ">
                <div class="hero-body">
                    <nav class="level ">
                        <!-- Left side -->
                        <div class="level-left ">
                            <div class="level-item">
                                <p class="title">
                                    <span class="icon is-medium">
                                        <i class="fa fa-home"></i>
                                    </span>
                                    <span class="icon is-medium">
                                        <i class="icon-list "></i>
                                    </span> Articulos de la sucursal
                                </p>
                            </div>
                        </div>

                        <!-- Right side -->
                        <div class="level-right ">
                            <div class="level-item">
                                <div class="field is-grouped">
                                    <div class="control has-icons-left is-expanded">
                                        <input type="text" class="input is-flat is-medium" placeholder="Buscar" #searchBox id="search-box" (keyup)="ctrl.buscar(searchBox.value)">
                                        <span class="icon is-medium is-left">
                                            <i class="icon-search3"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <a class="navbar-item tooltip" (click)="ctrl.listar(1)" id='cargar_datos_actualizar' *ngIf="!ctrl.busquedaActivada">
                                <span class="icon fa-2x">
                                    <i class="icon-worldwide"></i>
                                </span>
                                <span class="tooltiptext">Actualizar</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="ctrl.listarBusqueda(searchBox.value,1)" id='cargar_datos_actualizar' *ngIf="ctrl.busquedaActivada">
                                <span class="icon fa-2x">
                                    <i class="icon-worldwide"></i>
                                </span>
                                <span class="tooltiptext">Actualizar</span>
                            </a>

                            <a class="navbar-item tooltip" routerLink="/inventario/articulo/nuevo" >
                                <span class="icon fa-2x">
                                    <i class="icon-file"></i>
                                </span>
                                <span class="tooltiptext">Nuevo</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="ctrl.excel('Articulos de la sucursal');">
                                <span class="icon fa-2x">
                                    <i class="fa fa-file-excel-o"></i>
                                </span>
                                <span class="tooltiptext">Exportar Excel</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="ctrl.imprimir(null, '', 'Articulos de la sucursal');">
                                <span class="icon fa-2x">
                                    <i class="icon-printer2"></i>
                                </span>
                                <span class="tooltiptext">Imprimir</span>
                            </a>

                            <a class="navbar-item tooltip" (click)="imprimir_etiqueta();">
                                <span class="icon fa-2x">
                                    <i class="fa fa-tag"></i>
                                </span>
                                <span class="tooltiptext">Etiquetas</span>
                            </a>

                            <a class="navbar-item  is-dark tooltip" *ngIf="ctrl.busquedaActivada" (click)="ctrl.cerrar_busqueda(searchBox)">
                                <span class="icon fa-2x">
                                    <i class="fa fa-close"></i>
                                </span>
                                <span class="tooltiptext">Cerrar Busqueda</span>
                            </a>
                        </div>
                    </nav>
                </div>
            </section>

            <div class="is-fullwidth has-text-centered" *ngIf="ctrl.cargando">
                <br>
                <span class="tag is-primary is-large ">
                    <span class="icon">
                        <i class="icon-worldwide fa-spin"></i>
                    </span> &nbsp;
                    <span>Cargando...</span>
                </span>
                <br>
                <br>
            </div>

            <div id="exportar_datos" style="overflow-y:auto; overflow-x: hidden; display:block; height: 78.4vh;" >

                <!--Tabla -->
                <table class="table is-striped  is-fullwidth" *ngIf="ctrl.tipo_grid && !ctrl.cargando ">
                    <thead>
                        <tr>
                            <th>
                                <div class="b-checkbox is-info">
                                    <input id="etiquetas" class="styled" type="checkbox" (click)="todas_etiqueta(ctrl.dato)" [checked]="todos">
                                    <label for="etiquetas">
                                        Clave
                                    </label>
                                </div>
                            </th>

                            <th>Artículo</th>
                            <th>Existencia</th>
                            <th>Costo</th>
                            <th>Precio</th>
                            <th>Fraccionable</th>

                            <th width="1%" class="no_pdf">Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of ctrl.dato; let i=index" [ngClass]="{'blue-class': color[i]}">
                            <td>
                                <div class="b-checkbox is-info">
                                    <input id="etiqueta{{i}}" class="styled" type="checkbox" (click)="etiqueta(item)" [checked]="etiquetas.indexOf(item) > -1 ? true : false">
                                    <label for="etiqueta{{i}}">
                                        {{ item.codigo_barras }}
                                    </label>
                                </div>
                            </td>
                            <td style="vertical-align: middle;">
                                <strong>{{ item.nombre }}</strong>
                                <small>{{ item.descripcion }}</small>
                                <span class="tag is-success">
                                    <i class="icon-bookmark"></i> &nbsp; {{ item.categorias ? item.categorias.nombre : 'Sin categoria' }}</span>
                                <span class="tag is-danger">UM {{ item.unidades_medidas ? item.unidades_medidas.nombre : 'S/N' }} </span>
                            </td>
                            <td style="vertical-align: middle;">{{item.existencia}}</td>
                            <td style="vertical-align: middle;">{{ item.costos.length>0 ? item.costos[0].precio_con_impuestos : item.costo }}</td>
                            <td style="vertical-align: middle;">{{ item.articulos_precios.length>0 ? item.articulos_precios[0].precio : 'Sin precio' }} </td>


                            <td style="vertical-align: middle;">
                                <span *ngIf="item.es_fraccionable==0" class="tag is-info">
                                    <i class="fa fa-cube"></i>
                                </span>
                                <span *ngIf="item.es_fraccionable==1" class="tag is-warning">
                                    <i class="fa fa-cubes"></i>
                                </span>
                            </td>
                            <td style="vertical-align: middle;" class="has-text-centered no_pdf">
                                <!-- acciones -->
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-right">

                                        <!-- acciones -->
                                        <a (click)="abrirModal('ajuste_inventario', item, 5, i)" class="navbar-item tooltip" *ngIf="permisos.indexOf('ArticuloController.ajustemas') > -1 && item.stock_inicial > 0">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-add2"></i>
                                            </span>
                                            <span class="tooltiptext">Ajuste de Inventario +Mas</span>
                                        </a>
                                        <a (click)="abrirModal('ajuste_inventario', item, 6, i)" class="navbar-item tooltip" *ngIf="permisos.indexOf('ArticuloController.ajustemenos') > -1 && item.stock_inicial > 0">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-minus"></i>
                                            </span>
                                            <span class="tooltiptext">Ajuste de Inventario -Menos</span>
                                        </a>
                                    </div>
                                    <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                </nav>
                            </td>

                        </tr>
                        <tr *ngIf="ctrl.dato.length == 0">
                            <td colspan="7" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                        </tr>
                    </tbody>

                </table>

                <!--Lista -->
                <span *ngIf="!ctrl.tipo_grid && !ctrl.cargando" class="lista_lista">
                    <div class="box" *ngFor="let item of ctrl.dato; let i=index" style="margin-bottom:0.1rem;" [style.background]="i%2 == 0 ? '#fafafa' : '#ffffff'">
                        <article class="media">
                            <div class="media-left">
                                <figure class="image is-64x64">
                                    <img [src]="item.articulos_imagenes.length?ctrl.API_PATH+'/adjunto/articulos/'+item.articulos_imagenes[0].imagen:'./assets/128x128.png'"
                                        alt="Image">
                                </figure>
                            </div>
                            <div class="media-content" [ngClass]="{'blue-class': color[i]}">
                                <div class="content">
                                    <p>
                                        <strong class="tag is-link is-medium">{{item.nombre}}
                                            <small>( {{ item.unidades_medidas ? item.unidades_medidas.nombre : 'S/N' }} )</small>
                                        </strong>
                                        <small class="tag is-danger is-medium">
                                            <span class="icon">
                                                <i class="icon-credit-card-2"></i>
                                            </span> &nbsp; {{ item.costos.length>0 ? 'Costo: '+item.costos[0].precio_con_impuestos
                                            : item.costo }}</small>
                                        <small class="tag is-success is-medium">
                                            <span class="icon">
                                                <i class="icon-money3"></i>
                                            </span> &nbsp; {{ item.articulos_precios.length>0 ? 'Precio: '+item.articulos_precios[0].precio
                                            : 'Sin precio' }} </small>
                                        <small class="tag is-light is-medium">
                                            <span class="icon">
                                                <i class="fa fa-cubes"></i>
                                            </span> &nbsp; Existencia: {{item.existencia}}</small>

                                        <strong class="tag is-dark ">
                                            <span class="icon">
                                                <i class="fa fa-barcode"></i>
                                            </span> &nbsp; {{ item.codigo_barras }}</strong>
                                        <strong class="tag is-primary ">Categoria: {{ item.categorias ? item.categorias.nombre : 'Sin categoria' }}</strong>
                                    </p>
                                </div>
                                <nav class="level is-mobile" style="float:right">
                                    <div class="level-right">

                                        <!-- acciones -->
                                        <a (click)="abrirModal('ajuste_inventario', item, 5, i)" class="navbar-item tooltip" *ngIf="permisos.indexOf('ArticuloController.ajustemas') > -1 && item.stock_inicial > 0">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-add2"></i>
                                            </span>
                                            <span class="tooltiptext">Ajuste de Inventario +Mas</span>
                                        </a>
                                        <a (click)="abrirModal('ajuste_inventario', item, 6, i)" class="navbar-item tooltip" *ngIf="permisos.indexOf('ArticuloController.ajustemenos') > -1 && item.stock_inicial > 0">
                                            <span class="icon fa-2x has-text-success">
                                                <i class="icon-minus"></i>
                                            </span>
                                            <span class="tooltiptext">Ajuste de Inventario -Menos</span>
                                        </a>
                                    </div>
                                    <app-tabla-acciones [item]="item" [index]="i" [ctrl]="ctrl" class="level-left"></app-tabla-acciones>
                                </nav>
                            </div>
                        </article>
                    </div>
                </span>
              </div>
            <!-- Paginación para la lista  -->
            <app-paginacion [ctrl]="ctrl"></app-paginacion>

        </div>
    </div>
</div>

<div class="modal" id="ajuste_inventario">
    <div class="modal-background"></div>
    <div class="modal-card" style="width: 60%;">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <span class="icon">
                    <i class="icon-list-12"></i>
                </span> Ajuste de invetario {{articulo.tipos_movimientos_id == 5 ? 'MAS' : 'MENOS'}}
            </p>
            <button type="button" class="delete" (click)="cancelarModal('ajuste_inventario')"></button>
        </header>
        <section class="modal-card-body">
            <div *ngIf="articulo">
                <!-- GENERAL -->
                <div class="columns">
                    <div class="column is-3">
                        <label class="label">Clave:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="Clave" [(ngModel)]="articulo.clave" [ngModelOptions]="{standalone: true}" disabled>
                        </p>
                    </div>
                    <div class="column is-9">
                        <label class="label">Nombre:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="nombre" [(ngModel)]="articulo.nombre" [ngModelOptions]="{standalone: true}"
                                disabled>
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-4">
                        <label class="label">Categoría:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="nombre" [(ngModel)]="articulo.categorias.nombre" [ngModelOptions]="{standalone: true}"
                                disabled>
                        </p>
                    </div>

                    <div class="column is-4">
                        <label class="label">Presentación:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="nombre" [(ngModel)]="articulo.presentaciones.nombre" [ngModelOptions]="{standalone: true}"
                                disabled>
                        </p>
                    </div>

                    <div class="column is-4">
                        <label class="label">Unidad de medida:</label>
                        <p class="control has-icons-left has-icons-right">
                            <input class="input" type="text" placeholder="nombre" [(ngModel)]="articulo.unidades_medidas.nombre" [ngModelOptions]="{standalone: true}"
                                disabled>
                        </p>
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-12">
                    <div class="field">
                        <label class="label">Comentarios del ajuste:</label>
                        <div class="control">
                            <textarea class="textarea" maxlength="255" rows="4" placeholder="Describa el motivo del ajuste" [(ngModel)]="articulo.comentarios"
                                [ngModelOptions]="{standalone: true}">
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <section class="hero is-primary">
                <div>
                    Lista de stocks
                </div>
            </section>
            <table class="table is-striped  is-fullwidth">
                <thead>
                    <tr>
                        <th>
                            <abbr>Lote</abbr>
                        </th>
                        <th>Fecha de caducida</th>
                        <th>Ajsute</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of articulo.stocks; let i=index">
                        <td>{{item.lote}}</td>
                        <td>{{item.fecha_caducidad}}</td>
                        <td>
                            <div class="field">
                                <p class="control has-icons-left has-icons-right">
                                    <input class="input" type="number" step="1" min="0" placeholder="Ajuste" [(ngModel)]="item.ajuste" [ngModelOptions]="{standalone: true}">
                                </p>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="ajustar(articulo.index)">Guardar</a>
            <a class="button" (click)="cancelarModal('ajuste_inventario')">Cancelar</a>
        </footer>
    </div>
</div>

<div id="etiquetas_imp">
    <table width='100%' align='center' cellpadding='0' cellspacing='0' style='font-family:Arial, Helvetica, sans-serif'>
        <tr></tr>
        <tr *ngFor="let val of etiquetas; let i = index">
            <td style='max-height: 11mm;'>
                <table align='left' style='max-height: 11mm;'>
                    <tr style='max-height: 11mm;'>
                        <td width='25%' align='left'>
                            <div style='font-size:5pt;width:50px; margin-left:-10px; margin-top:-3px;'>{{val.material}} {{val.peso}}</div>
                        </td>

                        <td width='25%' align='center' valign='top'>
                            <div style='font-size:6pt;font-weight: bold; margin-top:-3px; margin-left:8px'>{{val.codigo_barras}}</div>
                            <div style='font-size:7pt;font-weight: bold; margin-left: 8px'>{{val.articulos_precios[0].precio  | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                        </td>
                        <td width='50%'></td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>

